import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import logo from '../Assets/Images/rklogo.png';
import logoLite from '../Assets/Images/rklite1.png';
import {
    setAccountType,
    setCurrentDeliveryAddress,
    setLoggedIn,
    setSellerCreation,
    setUserDetails,
} from '../Store/Auth/actions';
import { useHistory } from 'react-router-dom';
import { SlLocationPin } from 'react-icons/sl';
import { FaCartShopping, FaShop, FaShopLock } from 'react-icons/fa6';
import API from '../Common/API';
import { MdChecklist } from 'react-icons/md';
import { PiShoppingCartSimple } from 'react-icons/pi';
import { RxBookmark } from 'react-icons/rx';
import { FcShop } from 'react-icons/fc';
import { IoClose, IoPerson } from 'react-icons/io5';
import axios from 'axios';
import { FaPowerOff } from 'react-icons/fa';
import GlobalFilter from './GlobalFilter';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { GiHamburgerMenu } from 'react-icons/gi';
import { setRegions } from '../Store/Auth/actions';
import LanguageSwitcher from './LanguageSwitcher';
import { setLanguage } from '../Store/Theme/actions';
import { useTranslation } from 'react-i18next';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Dialog from './Dialog';

const globalFilter = {
    filterArea: '',
};

const TopBar = () => {
    const [categoryList, setCategoryList] = useState([]);
    const [globalFilterList, setGlobalFilterList] = useState([]);
    const dispatch = useDispatch();
    const history = useHistory();
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const [filter, setFilter] = useState('');
    const [openAll, setOpenAll] = useState(false);
    const [allProduct, setAllProduct] = useState([]);
    const [alreadyRegister, setAlreadyRegister] = useState();
    const userDetails = useSelector((state) => state.auth.userDetails);
    const [openSwitchDialog, setOpenSwitchDialog] = useState(false);
    const [user, setUser] = useState();
    const accountType = useSelector((state) => state.auth.accountType);
    const [loading, setLoading] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [region, setRegion] = useState(null);
    const [searchRegion, setSearchRegion] = useState(true);
    const [openAddressPopup, setOpenAddressPopup] = useState(false);
    const { t } = useTranslation();
    const lang = useSelector((state) => state.theme.language);
    const [deliveryAddress, setDeliveryAddress] = useState([]);
    const currentDeliveryAddress = useSelector((state) => state.auth.currentDeliveryAddress);

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('accountType');
        localStorage.removeItem('buyNowProducts');
        localStorage.removeItem('userDetails');
        dispatch(setUserDetails({}));
        dispatch(setLoggedIn(false));
        history.push('/');
        window.location.reload();
    };

    useEffect(() => {
        setLoading(true);
        if (isLoggedIn) {
            axios
                .all([
                    API.get('/users/getUserDetails'),
                    API.get(`/accounts/sellerAccount/${userDetails.subject._id}`),
                    API.get('/category/completeCategories'),
                    API.get('/category/getCategoryList'),
                    API.get('/users/getDeliveryAddress'),
                ])
                .then(
                    axios.spread((userRes, sellerRes, catRes, apiRes, addRes) => {
                        setUser(userRes.data.data);
                        // dispatch(setUserDetails({ subject: userRes.data.data }))
                        setAlreadyRegister(sellerRes.data.data);
                        setAllProduct(catRes.data.data);
                        setCategoryList(apiRes.data.data);
                        setDeliveryAddress(addRes.data.data);
                        setGlobalFilterList(
                            apiRes.data.data.map((c) => ({ text: c.category, value: c._id }))
                        );
                        if (localStorage.getItem('region')) {
                            const place = JSON.parse(localStorage.getItem('region'));
                            dispatch(setRegions(place));
                            setRegion(place.city + ',' + place.district + ',' + place.state);
                        }
                        setLoading(false);
                    })
                );
        } else {
            axios
                .all([
                    API.get('/category/completeCategories'),
                    API.get('/category/getCategoryList'),
                ])
                .then(
                    axios.spread((catRes, apiRes) => {
                        setCategoryList(apiRes.data.data);
                        setGlobalFilterList(
                            apiRes.data.data.map((c) => ({ text: c.category, value: c._id }))
                        );
                        setAllProduct(catRes.data.data);
                        if (localStorage.getItem('region')) {
                            const place = JSON.parse(localStorage.getItem('region'));
                            dispatch(setRegions(place));
                            setRegion(place.city + ',' + place.district + ',' + place.state);
                        }
                    })
                );
        }
        setLoading(false);
    }, []); // eslint-disable-line

    const viewProducts = (value) => {
        if (value === 'all') {
            setOpenAll(!openAll);
        } else {
            history.push(
                `/shopping/category/${categoryList?.filter((x) => x?.category === value)[0]?._id}`
            );
            setOpenAll(false);
        }
    };

    const becomeSeller = () => {
        if (isLoggedIn) {
            history.push('/createSellerAccount');
        } else {
            dispatch(setSellerCreation(true));
            history.push('/auth/login');
        }
    };

    const switchAccount = () => {
        setOpenSwitchDialog(!openSwitchDialog);
    };

    const switchToAccount = (value) => {
        localStorage.setItem('accountType', value);
        dispatch(setAccountType(value));
        setOpenSwitchDialog(false);
    };

    useEffect(() => {
        if (accountType === 'user') {
            history.push('/');
        } else if (accountType === 'seller') {
            history.push(`/store/${userDetails.subject.sellerId._id}/`);
        }
    }, [accountType]);

    const filterSchema = Yup.object().shape({
        filterArea: Yup.string().nullable(),
    });

    const filterForm = useFormik({
        initialValues: globalFilter,
        validateOnMount: true,
        validationSchema: filterSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log(values);
        },
    });

    const viewSubProducts = (value) => {
        console.log(value);
        history.push(`/shopping/category/${value.categoryId}/${value._id}`);
        setOpenAll(false);
    };

    const getLocation = (values) => {
        API.post('/common/getLocationByCode', { pinCode: values }).then((res) => {
            if (res.status === 200) {
                const place = res.data.data;
                setRegion(place.city + ',' + place.district + ',' + place.state);
                localStorage.setItem('region', JSON.stringify(place));
                dispatch(setRegions(place));
                setSearchRegion(false);
            }
        });
    };

    const selectAddress = (values) => {
        dispatch(setCurrentDeliveryAddress(values));
        localStorage.setItem('currentDeliveryAddress', JSON.stringify(values));
        setOpenAddressPopup(false);
    };

    return (
        <>
            <motion.div className="flex z-50 flex flex-col bg-neutral-900 md:py-2 relative w-full">
                <motion.div className="flex text-white flex-row items-center px-2 justify-around">
                    <img
                        src={logoLite}
                        alt="logo"
                        className="cursor-pointer"
                        height={100}
                        width={100}
                        onClick={() =>
                            userDetails?.subject?.accountType !== 'seller'
                                ? history.push('/')
                                : history.push(`/store/${userDetails.subject.sellerId}/`)
                        }
                    />
                    {userDetails?.subject?.accountType !== 'seller' && (
                        <motion.div className={`flex w-72 mx-2 flex-row items-center`}>
                            <SlLocationPin className={'text-sm md:text-3xl font-bold'} />
                            <motion.div
                                className="cursor-pointer text-sm h-full w-52 flex flex-col items-center justify-center"
                                onClick={() => setOpenAddressPopup(true)}
                            >
                                {currentDeliveryAddress &&
                                JSON.stringify(currentDeliveryAddress).toString().length > 2
                                    ? `${t('Delivery to')} ${currentDeliveryAddress.city}   ${
                                          currentDeliveryAddress.pinCode
                                      }`
                                    : 'Select or update the address'}
                                <br />
                                {t('Update location')}
                            </motion.div>
                        </motion.div>
                    )}
                    {userDetails?.subject?.accountType !== 'seller' ? (
                        <motion.div
                            className={`w-[600px] md:flex hidden flex flex-row items-center`}
                        >
                            <GlobalFilter
                                placeholder={t('Search your needs')}
                                injectClass={'w-full ring-2 ring-[black] text-white'}
                                value={filter}
                                setValue={setFilter}
                            />
                        </motion.div>
                    ) : (
                        <motion.div className="w-[600px]"></motion.div>
                    )}
                    <LanguageSwitcher onToggle={(lang) => dispatch(setLanguage(lang))} />
                    <Menu as="div" className="relative  inline-block text-left">
                        <div>
                            <MenuButton className="inline-flex w-[200px]  justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm font-semibold text-white ring-1 shadow-xs ring-gray-300 ring-inset">
                                {t('Hello')},{' '}
                                {userDetails &&
                                userDetails?.subject &&
                                userDetails?.subject?.accountType !== 'seller'
                                    ? userDetails?.subject?.firstName
                                    : userDetails?.subject?.accountType === 'seller'
                                    ? userDetails?.subject?.accountName
                                    : t('Sign in')}
                                ,<br />
                                {t('Account & Lists')}
                                <ChevronDownIcon
                                    aria-hidden="true"
                                    className="-mr-1 size-5 text-gray-400"
                                />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-50 mt-2 min-w-56 w-auto origin-top-right rounded-md bg-white ring-1 shadow-lg ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <motion.div
                                        className={`flex  cursor-pointer font-bold text-[black] text-center items-center flex-row px-5 py-2`}
                                        onClick={() =>
                                            isLoggedIn
                                                ? history.push('/account')
                                                : history.push('/auth/login')
                                        }
                                    >
                                        <IoPerson />
                                        <p className="mx-5">{t('Account')}</p>
                                    </motion.div>
                                </MenuItem>
                                {userDetails?.subject?.accountType !== 'seller' && (
                                    <MenuItem>
                                        <motion.div
                                            className={`flex  cursor-pointer font-bold text-[black] text-center items-center flex-row px-5 py-2`}
                                            onClick={() =>
                                                isLoggedIn
                                                    ? history.push('/orders')
                                                    : history.push('/auth/login')
                                            }
                                        >
                                            <MdChecklist />
                                            <p className="mx-5">{t('Orders')}</p>
                                        </motion.div>
                                    </MenuItem>
                                )}
                                {userDetails?.subject?.accountType !== 'seller' && (
                                    <MenuItem>
                                        <motion.div
                                            className={`flex  cursor-pointer font-bold text-[black] text-center items-center flex-row px-5 py-2`}
                                            onClick={() =>
                                                isLoggedIn
                                                    ? history.push('/cart')
                                                    : history.push('/auth/login')
                                            }
                                        >
                                            <PiShoppingCartSimple />
                                            <p className="mx-5">{t('Cart')}</p>
                                        </motion.div>
                                    </MenuItem>
                                )}
                                {userDetails?.subject?.accountType !== 'seller' && (
                                    <MenuItem>
                                        <motion.div
                                            className={`flex  cursor-pointer font-bold text-[black] text-center items-center flex-row px-5 py-2`}
                                            onClick={() =>
                                                isLoggedIn
                                                    ? history.push('/wishlist')
                                                    : history.push('/auth/login')
                                            }
                                        >
                                            <RxBookmark />
                                            <p className="mx-5">{t('Wishlist')}</p>
                                        </motion.div>
                                    </MenuItem>
                                )}
                                {userDetails?.subject?.accountType !== 'seller' && (
                                    <MenuItem>
                                        {loading ? (
                                            'Loading ...'
                                        ) : !isLoggedIn &&
                                          (alreadyRegister === null ||
                                              alreadyRegister === undefined) ? (
                                            <motion.div
                                                className={`flex  cursor-pointer font-bold text-[black] text-center items-center flex-row px-5 py-2`}
                                                onClick={() => becomeSeller()}
                                            >
                                                <FaShopLock />
                                                <p className="mx-5">{t('Become a seller')}</p>
                                            </motion.div>
                                        ) : alreadyRegister === null ||
                                          alreadyRegister === undefined ||
                                          alreadyRegister.status === 'Pending' ||
                                          alreadyRegister.status === 'Reject' ? (
                                            <motion.div
                                                className={`flex  cursor-pointer font-bold text-[black] text-center items-center flex-row px-5 py-2`}
                                                onClick={() => becomeSeller()}
                                            >
                                                <FaShopLock />
                                                <p className="mx-5">{t('Become a seller')}</p>
                                            </motion.div>
                                        ) : (
                                            <motion.div
                                                className="text-md underline cursor-pointer font-bold flex items-center"
                                                onClick={() => switchAccount()}
                                            >
                                                {accountType === 'user' ? (
                                                    <IoPerson className="mx-2 text-[#002557]" />
                                                ) : (
                                                    <FcShop className="mx-2" />
                                                )}
                                                {t('Switch Accounts')}
                                            </motion.div>
                                        )}
                                    </MenuItem>
                                )}
                                <MenuItem>
                                    {isLoggedIn ? (
                                        <motion.div
                                            className={`flex  cursor-pointer font-bold text-[black] text-center items-center flex-row px-5 py-2`}
                                            onClick={() => logout()}
                                        >
                                            <FaPowerOff />
                                            <p className="mx-2"> {t('Logout')}</p>
                                        </motion.div>
                                    ) : (
                                        <motion.div
                                            className={`flex  cursor-pointer font-bold text-[black] text-center items-center flex-row px-5 py-2`}
                                            onClick={() => history.push('/auth/login')}
                                        >
                                            <FaPowerOff />
                                            <p className="mx-2"> {t('Login')}</p>
                                        </motion.div>
                                    )}
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                    <motion.div
                        className={'cursor-pointer w-fit px-2 text-md'}
                        onClick={() =>
                            isLoggedIn ? history.push('/orders') : history.push('/auth/login')
                        }
                    >
                        {t('Returns & Orders')}
                    </motion.div>
                    <motion.div
                        className={`flex w-fit cursor-pointer font-bold text-white text-center items-center flex-row gap-2`}
                        onClick={() =>
                            isLoggedIn ? history.push('/cart') : history.push('/auth/login')
                        }
                    >
                        <FaCartShopping />
                        {t('Cart')}
                    </motion.div>
                </motion.div>
                {userDetails?.subject?.accountType !== 'seller' && (
                    <motion.div className="flex z-10 bg-neutral-500 relative py-2 md:py-0 relative md:px-5 drop-shadow-lg text-white font-bold flex-row w-full items-center justify-start h-auto md:h-10">
                        <motion.div
                            className="cursor-pointer flex flex-row items-center mx-1 md:mx-4"
                            onClick={() => viewProducts('all')}
                        >
                            {<GiHamburgerMenu />}&nbsp;{t('All Products')}
                        </motion.div>
                        {openAll && (
                            <motion.div className="absolute bg-[white] bg-white w-full h-screen overflow-scroll top-8 left-0 right-0 drop-shadow-lg">
                                {/* Content of the dropdown */}
                                <motion.div className="py-2 grid grid-cols-1  sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 lg:grid-cols-3 px-4">
                                    {allProduct.map((pro) => {
                                        return (
                                            <motion.div
                                                key={pro.category}
                                                className={'flex flex-col mx-2 px-1 py-1'}
                                            >
                                                <p className={'text-[#002557] font-bold'}>
                                                    {lang === 'en'
                                                        ? pro.category
                                                        : pro.categoryTamil}
                                                </p>
                                                {pro.subCategories.map((subCat, j) => {
                                                    return (
                                                        <motion.div
                                                            key={j}
                                                            className={
                                                                'flex text-black flex-col cursor-pointer mx-2 px-2 py-1'
                                                            }
                                                            onClick={() => viewSubProducts(subCat)}
                                                        >
                                                            {lang === 'en'
                                                                ? subCat.subCategory
                                                                : subCat.subCategoryTamil}
                                                        </motion.div>
                                                    );
                                                })}
                                            </motion.div>
                                        );
                                    })}
                                </motion.div>
                            </motion.div>
                        )}
                        <motion.div
                            className="cursor-pointer mx-4 sm:mx-2"
                            onClick={() => viewProducts('Furniture')}
                        >
                            {t('Furniture')}
                        </motion.div>
                        <motion.div
                            className="cursor-pointer mx-4 sm:mx-2"
                            onClick={() => viewProducts('Electronics')}
                        >
                            {t('Electronics')}
                        </motion.div>
                    </motion.div>
                )}
            </motion.div>
            <Dialog
                title={'Switch Accounts'}
                injectClass="w-[410px]"
                showDialog={openSwitchDialog}
                onClose={() => setOpenSwitchDialog(false)}
            >
                <motion.div className="flex my-5 flex-col">
                    <motion.div
                        className="cursor-pointer items-center text-md font-bold flex flex-row"
                        onClick={() => switchToAccount('user')}
                    >
                        <IoPerson className="mx-2" />
                        {user?.firstName}&nbsp;{user?.lastName}
                    </motion.div>
                    <br />
                    <motion.div
                        className="cursor-pointer flex flex-row items-center text-md font-bold"
                        onClick={() => switchToAccount('seller')}
                    >
                        <FaShop className="mx-2" />
                        {user?.sellerId?.accountName}
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog
                title={t('Choose your location')}
                injectClass={'w-[460px]'}
                showDialog={openAddressPopup}
                onClose={() => setOpenAddressPopup(false)}
            >
                {isLoggedIn ? (
                    <motion.div className="py-2 flex flex-col items-center">
                        <p>
                            {t(
                                'Select a delivery location to see product availability and delivery options'
                            )}
                        </p>
                        <motion.div className="grid grid-cols-1 gap-2 w-full">
                            {deliveryAddress.map((address, i) => {
                                return (
                                    i <= 4 && (
                                        <motion.div
                                            key={i}
                                            className="w-full rounded-xl cursor-pointer px-5 py-2 min-h-20 h-auto border border-grey drop-shadow-md"
                                            onClick={() => selectAddress(address)}
                                        >
                                            <p className="font-bold">{address.name}</p>
                                            <motion.div className="w-full flex flex-row flex-wrap">
                                                <p>{address.addressLine1},</p>
                                                {address.addressLine2 && (
                                                    <p>{address.addressLine2},</p>
                                                )}
                                                <p>{address.city},</p>
                                                <p>
                                                    {address.district} - {address.pinCode},
                                                </p>
                                                <p>{address.state}</p>
                                            </motion.div>
                                            <p className="font-bold">{address.mobileNumber}</p>
                                        </motion.div>
                                    )
                                );
                            })}
                        </motion.div>
                        <motion.div className="flex flex-row items-center text-center justify-center w-full px-2 py-2 rounded-full">
                            {
                                <motion.div className="flex flex-row w-full justify-start">
                                    {deliveryAddress && deliveryAddress.length > 5 && (
                                        <p className="text-primeColor">See All</p>
                                    )}{' '}
                                    &nbsp;&nbsp;
                                    <p
                                        className="text-primeColor cursor-pointer"
                                        onClick={() => {
                                            history.push('/addAddress');
                                            setOpenAddressPopup(false);
                                        }}
                                    >
                                        Add an address
                                    </p>
                                </motion.div>
                            }
                        </motion.div>
                    </motion.div>
                ) : (
                    <motion.div className="py-2 flex flex-col items-center">
                        <p>
                            {t(
                                'Select a delivery location to see product availability and delivery options'
                            )}
                        </p>
                        <motion.div
                            className="flex flex-row items-center text-center justify-center bg-primeColor text-black cursor-pointer w-full px-2 py-2 rounded-full cursor-pointer"
                            onClick={() => history.push('/auth/login')}
                        >
                            {t('Sign in to see your addresses')}
                        </motion.div>
                        <motion.div className="flex flex-row justify-center items-center my-5">
                            <div
                                className={`h-[2px] ${
                                    lang === 'ta' ? 'w-12' : 'w-28'
                                } bg-[lightGrey]`}
                            />
                            &nbsp;<p>{t('Or enter an indian pincode')}</p>&nbsp;
                            <div
                                className={`h-[2px] ${
                                    lang === 'ta' ? 'w-12' : 'w-28'
                                } bg-[lightGrey]`}
                            />
                        </motion.div>
                        <motion.div className="w-full flex flex-row justify-center">
                            <input type="text" className="w-full border border-black px-2 py-1 " />
                            <motion.div className="bg-white border border-black text-black w-52 flex flex-row justify-center items-center mx-2 cursor-pointer rounded-full px-2 py-2">
                                Apply
                            </motion.div>
                        </motion.div>
                    </motion.div>
                )}
            </Dialog>
        </>
    );
};

export default TopBar;
